export const UnknownJobId = 'unknown';

export class JobStub {
    private static unknownJob: JobStub;

    readonly id: string;
    readonly title: string;

    constructor(startingValues?: Partial<JobStub>) {
        Object.assign(this, startingValues);
    }

    getDisplay() {
        return this.title;
    }

    isUnknown() {
        return this.id === UnknownJobId;
    }
}

export const JobStubForUnknown = new JobStub({
    id: UnknownJobId,
    title: UnknownJobId
});
